export default function IconButton({ icon, sx, onClick, rest }) {
  return (
    <div className="icon-button" style={sx} onClick={onClick} {...rest}>
      {icon}
    </div>
  );
}
